import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12.75 3.035v.568c0 .334.148.65.405.864l1.068.89c.442.369.535 1.01.216 1.489l-.51.766a2.25 2.25 0 0 1-1.161.887l-.143.047a1.107 1.107 0 0 0-.57 1.665 1.108 1.108 0 0 1-.427 1.605L9 13.13l.423 1.058a.956.956 0 0 1-1.652.928l-.679-.905a1.125 1.125 0 0 0-1.906.172L4.5 15.755l-.612.153M12.75 3.035a9 9 0 0 0-8.862 12.872M12.75 3.036a9 9 0 0 1 6.69 14.037m0 0-.177-.529a2.25 2.25 0 0 0-2.135-1.538H16.5l-.324-.325a1.453 1.453 0 0 0-2.328.378l-.036.073a1.6 1.6 0 0 1-.982.815l-.99.283c-.55.157-.894.702-.8 1.266l.073.438c.08.474.49.822.97.822.846 0 1.598.541 1.865 1.344l.215.644m5.276-3.671a9 9 0 0 1-5.276 3.671m0 0a9 9 0 0 1-2.163.262 9 9 0 0 1-8.112-5.097M15.75 9.005c0 .896-.393 1.7-1.016 2.25"
    }, null, -1)
  ])))
}
export default { render: render }